import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import LogoutIcon from '@mui/icons-material/Logout';
import LanguageDropdown from '@/common/components/NavigationBar/components/LanguageDropdown';
import Profile from '@/common/components/NavigationBar/components/Profile';
import useLogoutIntentStore from '@/common/stores/logout-intent';
import { routes } from '@/app/routing/index';
import Footer from '@/common/components/NavigationBar/components/Footer';

const Control = ({ admin }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const requestLogout = useLogoutIntentStore((state) => state.requestLogout);
  const { t } = useTranslation();

  const logout = () => {
    const nextPath = pathname.includes(routes.adminPanel.index)
      ? routes.adminLogin
      : routes.login;

    requestLogout(nextPath);
    history.replace(nextPath);
  };

  if (admin) {
    return (
      <Box width="100%" px={6} py={2}>
        <Button
          onClick={logout}
          variant="text"
          color="secondary"
          size="medium"
          sx={{ justifyContent: 'flex-start' }}
          startIcon={<LogoutIcon sx={{ fontSize: 20 }} />}
          fullWidth
        >
          {t('Log out')}
        </Button>
      </Box>
    );
  }

  return (
    <>
      <Box
        width="100%"
        px={6}
        py={2}
        borderBottom="1px solid"
        borderTop="1px solid"
        borderColor="divider"
      >
        <LanguageDropdown wullWidth />
      </Box>
      <Profile />
      <Footer />
    </>
  );
};

export default Control;
